var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_66_14175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.41747 8.65488C4.34998 8.64073 4.28595 8.61341 4.22905 8.57446C4.17214 8.53552 4.12348 8.48573 4.08586 8.42795C4.04823 8.37016 4.02238 8.30552 4.00979 8.23773C3.9972 8.16993 3.99811 8.10032 4.01247 8.03288L4.99847 3.41588C5.0127 3.34807 5.04024 3.28375 5.0795 3.22665C5.11875 3.16956 5.16894 3.12081 5.22716 3.08324C5.28538 3.04567 5.35047 3.02001 5.41867 3.00776C5.48687 2.99552 5.55682 2.99691 5.62447 3.01188L20.5825 6.17388C20.8675 6.23388 21.0495 6.51288 20.9885 6.79588L20.0015 11.4139C19.9872 11.4816 19.9597 11.5458 19.9205 11.6028C19.8813 11.6598 19.8313 11.7085 19.7731 11.7461C19.715 11.7837 19.6501 11.8093 19.582 11.8217C19.5139 11.834 19.4441 11.8327 19.3765 11.8179L15.0315 10.8979C14.8335 10.8579 14.7165 10.9219 14.6785 11.0949L12.6505 20.5849C12.621 20.7212 12.5386 20.8403 12.4215 20.9161C12.3043 20.9918 12.1619 21.018 12.0255 20.9889L7.38347 20.0069C7.24739 19.9778 7.12832 19.8961 7.05226 19.7796C6.9762 19.663 6.94931 19.5212 6.97747 19.3849L9.00547 9.89188C9.04247 9.72188 8.97447 9.61788 8.80147 9.58188L4.41747 8.65488Z",
    stroke: "#3E76B6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_66_14175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopic);
export default __webpack_public_path__ + "static/media/TOPIC.02ad37869eb1096f0cde2b37fcfd988b.svg";
export { ForwardRef as ReactComponent };